export const getSafeAculLink = (href?: string | null): string | null => {
  if (!href) {
    return null;
  }

  const normalizedHref = href.trim();
  if (!normalizedHref) {
    return null;
  }

  const invalidValues = new Set(["none", "null", "undefined", "#"]);
  if (invalidValues.has(normalizedHref.toLowerCase())) {
    return null;
  }

  if (/^javascript:/i.test(normalizedHref)) {
    return null;
  }

  return normalizedHref;
};

export const hasAculOrganizationContext = (organization?: unknown): boolean => {
  if (!organization || typeof organization !== "object") {
    return false;
  }

  return Object.values(organization as Record<string, unknown>).some(
    (value) => value !== undefined && value !== null && value !== ""
  );
};

export const hasAculInvitationContext = (signupLink?: string | null): boolean => {
  const candidates = [
    signupLink,
    typeof window !== "undefined" ? window.location.pathname : null,
  ];

  return candidates.some((value) => value?.includes("/invitation"));
};
